import { Link } from "react-router-dom";

export function PrivacyPage() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-20">
      <h1 className="text-3xl font-bold mb-8">Politique de Confidentialite</h1>
      <div className="text-[#94A3B8] text-sm leading-relaxed space-y-6">
        <p><strong className="text-white">Derniere mise a jour :</strong> {new Date().toLocaleDateString("fr-FR")}</p>
        <section>
          <h2 className="text-white text-lg font-semibold mb-3">1. Responsable du traitement</h2>
          <p>GLOTECH DIGITAL, representee par son dirigeant.<br />Email : contactac@glotechdigital.fr<br />Telephone : 06 01 15 04 41</p>
        </section>
        <section>
          <h2 className="text-white text-lg font-semibold mb-3">2. Donnees collectees</h2>
          <p>Nous collectons les donnees suivantes dans le cadre de nos services :</p>
          <ul className="list-disc pl-6 space-y-1 mt-2">
            <li>Donnees d'identification : nom, prenom, email, telephone</li>
            <li>Donnees professionnelles : nom d'entreprise, secteur d'activite, adresse</li>
            <li>Donnees de navigation : pages visitees, duree de session (via Google Analytics)</li>
            <li>Donnees commerciales : devis, contrats, factures</li>
          </ul>
        </section>
        <section>
          <h2 className="text-white text-lg font-semibold mb-3">3. Finalites du traitement</h2>
          <ul className="list-disc pl-6 space-y-1">
            <li>Gestion de la relation client et commerciale</li>
            <li>Execution des prestations de services</li>
            <li>Facturation et suivi des paiements</li>
            <li>Amelioration de nos services et de notre site web</li>
            <li>Communication marketing (avec consentement)</li>
          </ul>
        </section>
        <section>
          <h2 className="text-white text-lg font-semibold mb-3">4. Base legale</h2>
          <p>Le traitement de vos donnees repose sur : l'execution d'un contrat, votre consentement, notre interet legitime ou une obligation legale.</p>
        </section>
        <section>
          <h2 className="text-white text-lg font-semibold mb-3">5. Duree de conservation</h2>
          <p>Vos donnees sont conservees pendant la duree de la relation commerciale et 3 ans apres la fin de celle-ci, sauf obligation legale de conservation plus longue.</p>
        </section>
        <section>
          <h2 className="text-white text-lg font-semibold mb-3">6. Vos droits</h2>
          <p>Conformement au RGPD, vous disposez des droits suivants :</p>
          <ul className="list-disc pl-6 space-y-1 mt-2">
            <li>Droit d'acces a vos donnees</li>
            <li>Droit de rectification</li>
            <li>Droit a l'effacement (droit a l'oubli)</li>
            <li>Droit a la limitation du traitement</li>
            <li>Droit a la portabilite</li>
            <li>Droit d'opposition</li>
          </ul>
          <p className="mt-2">Pour exercer vos droits, contactez-nous a : <a href="mailto:contactac@glotechdigital.fr" className="text-[#0099CC] hover:underline">contactac@glotechdigital.fr</a></p>
        </section>
        <section>
          <h2 className="text-white text-lg font-semibold mb-3">7. Demande de suppression</h2>
          <p>Vous pouvez demander la suppression de l'ensemble de vos donnees personnelles en nous contactant par email. Nous traiterons votre demande dans un delai de 30 jours.</p>
        </section>
        <section>
          <h2 className="text-white text-lg font-semibold mb-3">8. Securite</h2>
          <p>Nous mettons en oeuvre des mesures techniques et organisationnelles appropriees pour proteger vos donnees : chiffrement SSL/TLS, acces restreint, sauvegardes regulieres.</p>
        </section>
      </div>
    </div>
  );
}

export function CookiesPage() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-20">
      <h1 className="text-3xl font-bold mb-8">Politique de Cookies</h1>
      <div className="text-[#94A3B8] text-sm leading-relaxed space-y-6">
        <section>
          <h2 className="text-white text-lg font-semibold mb-3">Qu'est-ce qu'un cookie ?</h2>
          <p>Un cookie est un petit fichier texte depose sur votre navigateur lors de la visite d'un site web. Il permet de stocker des informations relatives a votre navigation.</p>
        </section>
        <section>
          <h2 className="text-white text-lg font-semibold mb-3">Cookies utilises</h2>
          <div className="bg-[#151B2B] border border-[#2A3441] rounded-lg overflow-hidden mt-3">
            <table className="w-full text-sm">
              <thead><tr className="border-b border-[#2A3441]"><th className="text-left p-3 text-white">Cookie</th><th className="text-left p-3 text-white">Finalite</th><th className="text-left p-3 text-white">Duree</th></tr></thead>
              <tbody>
                <tr className="border-b border-[#2A3441]"><td className="p-3">Session Auth</td><td className="p-3">Authentification utilisateur</td><td className="p-3">Session</td></tr>
                <tr className="border-b border-[#2A3441]"><td className="p-3">_ga, _gid</td><td className="p-3">Google Analytics (mesure d'audience)</td><td className="p-3">13 mois</td></tr>
                <tr><td className="p-3">cookie_consent</td><td className="p-3">Memoriser votre choix de cookies</td><td className="p-3">12 mois</td></tr>
              </tbody>
            </table>
          </div>
        </section>
        <section>
          <h2 className="text-white text-lg font-semibold mb-3">Gestion des cookies</h2>
          <p>Vous pouvez a tout moment modifier vos preferences de cookies via les parametres de votre navigateur ou en nous contactant.</p>
        </section>
      </div>
    </div>
  );
}

export function LegalPage() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-20">
      <h1 className="text-3xl font-bold mb-8">Mentions Legales</h1>
      <div className="text-[#94A3B8] text-sm leading-relaxed space-y-6">
        <section>
          <h2 className="text-white text-lg font-semibold mb-3">Editeur du site</h2>
          <p>GLOTECH DIGITAL<br />Email : contactac@glotechdigital.fr<br />Telephone : 06 01 15 04 41<br />Site web : www.glotechdigital.fr</p>
        </section>
        <section>
          <h2 className="text-white text-lg font-semibold mb-3">Directeur de la publication</h2>
          <p>Le representant legal de GLOTECH DIGITAL.</p>
        </section>
        <section>
          <h2 className="text-white text-lg font-semibold mb-3">Hebergement</h2>
          <p>Le site est heberge par des prestataires d'infrastructure cloud certifies, garantissant la securite et la disponibilite des donnees.</p>
        </section>
        <section>
          <h2 className="text-white text-lg font-semibold mb-3">Propriete intellectuelle</h2>
          <p>L'ensemble du contenu du site (textes, images, graphismes, logo, icones) est la propriete exclusive de GLOTECH DIGITAL. Toute reproduction, representation ou diffusion sans autorisation est interdite.</p>
        </section>
        <section>
          <h2 className="text-white text-lg font-semibold mb-3">Protection des donnees</h2>
          <p>Conformement au RGPD, vous disposez de droits sur vos donnees personnelles. Consultez notre <Link to="/politique-confidentialite" className="text-[#0099CC] hover:underline">politique de confidentialite</Link> pour plus d'informations.</p>
        </section>
        <section>
          <h2 className="text-white text-lg font-semibold mb-3">Credits</h2>
          <p>Cree par GLOTECH DIGITAL &mdash; Plateforme GLOTECH OS.</p>
        </section>
      </div>
    </div>
  );
}
